import React from "react";
import NCLoader from "./NC-Loader";

export function Loading() {
  return (
    <NCLoader
      classes={" bg-[#000000b2] "}
      logoColor={"#20AB24"}
      loaderContentBgColor='transperant'
      variantType={"ninja"}
      labelColor={"#ffffff"}
      label={"Loading..."}
      color={"#1FAB24"}
      size={"md"}
      borderWidth={"4"}
      labelMargin={"1"}
      fontWeight={true}
    />
  );
}
